module.exports = __webpack_public_path__ + "img/night_ezn.67396d1c.gif";